// Stimulus controller responsible for rendering toasts when a turbo-stream replaces #toast-payload
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    message: String,
    status: String
  }

  connect() {
    const container = document.getElementById("toast-container")
    if (!container) {
      console.warn("outlet-sync-toast: #toast-container not found")
      return
    }

    const msg = this.hasMessageValue ? this.messageValue : "Done"
    const status = this.hasStatusValue ? this.statusValue : "success"

    const toast = this.buildToastElement(msg, status)
    toast.classList.add("pointer-events-auto")
    container.appendChild(toast)

    setTimeout(() => this.dismiss(toast), 6000)

    // remove the payload element to keep DOM clean
    this.element.remove()
  }

  buildToastElement(message, status) {
    const wrapper = document.createElement("div")
    wrapper.className = "max-w-sm w-full mb-4 rounded-md shadow-lg overflow-hidden transform transition duration-150 ease-out"

    const base = "px-4 py-3 flex items-start gap-3 text-sm font-medium"
    let statusClasses = "bg-white text-gray-800"
    if (status === "success") {
      statusClasses = "bg-emerald-50 text-emerald-800 border border-emerald-200"
    } else if (status === "error") {
      statusClasses = "bg-red-50 text-red-800 border border-red-200"
    } else {
      statusClasses = "bg-gray-50 text-gray-800 border border-gray-200"
    }

    wrapper.innerHTML = `
      <div class="${base} ${statusClasses}">
        <div class="flex-1">${this.escapeHtml(message)}</div>
        <button class="ml-3 text-sm leading-5 focus:outline-none" data-action="click->outlet-sync-toast#onClose">
          ✕
        </button>
      </div>
    `

    const btn = wrapper.querySelector("button")
    if (btn) btn.addEventListener("click", (e) => {
      e.preventDefault()
      this.dismiss(wrapper)
    })

    return wrapper
  }

  onClose(event) {
    event.preventDefault()
    const toastEl = event.currentTarget.closest("div")
    if (toastEl) this.dismiss(toastEl)
  }

  dismiss(el) {
    if (!el) return
    el.style.transition = "opacity 160ms ease-out, transform 160ms ease-out"
    el.style.opacity = "0"
    el.style.transform = "translateY(-8px)"
    setTimeout(() => el.remove(), 180)
  }

  escapeHtml(unsafe) {
    if (!unsafe) return ""
    return unsafe.replaceAll("&", "&amp;")
                 .replaceAll("<", "&lt;")
                 .replaceAll(">", "&gt;")
                 .replaceAll('"', "&quot;")
                 .replaceAll("'", "&#039;")
  }
}
